// hack for ios14 Bug with tab highlighting TUB-14518 and TUB-14386

const init = () => {
  if (!isOldIos()) {
    return;
  }

  const style = document.createElement("style");
  style.innerHTML = `
        button, input, a {
            -webkit-tap-highlight-color: transparent;
        }
    `;
  document.head.appendChild(style);
};

function isOldIos() {
  const version = _getMajorIosVersion();

  if (!version) {
    return;
  }

  return (
    (window.navigator.platform === "MacIntel" ||
      window.navigator.platform === "iPhone") &&
    window.navigator.maxTouchPoints > 1 &&
    version <= 14
  );
}

function _getMajorIosVersion() {
  const version = window.navigator.userAgent.match(
    /Version\/(\d+)\.(\d+)\.?(\d+)?/
  );

  if (!version) {
    return;
  }

  return version[1];
}

export { init };
